(function () {
  'use strict';

  function init(formEl) {
    if (!formEl || formEl.dataset.bisInit === '1') return;
    formEl.dataset.bisInit = '1';

    var COMPANY_ID = formEl.dataset.klaviyoCompanyId || 'TH64eF';
    var LIST_ID = formEl.dataset.klaviyoListId || '';
    var REVISION = '2024-10-15';
    var SUBSCRIBE_URL = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + COMPANY_ID;
    var EVENT_URL = 'https://a.klaviyo.com/client/events/?company_id=' + COMPANY_ID;

    var productHandle = formEl.dataset.productHandle || '';
    var productTitle = formEl.dataset.productTitle || '';
    var productId = formEl.dataset.productId || '';
    var productUrl = formEl.dataset.productUrl || '';
    var productImageUrl = formEl.dataset.productImageUrl || '';
    var productPrice = formEl.dataset.productPrice || '';
    var productPriceCentsRaw = formEl.dataset.productPriceCents;
    var productPriceCents = productPriceCentsRaw ? parseInt(productPriceCentsRaw, 10) : null;

    var emailInput = formEl.querySelector('[data-bis-email]');
    var submitBtn = formEl.querySelector('[data-bis-submit]');
    var errorEl = formEl.querySelector('[data-bis-error]');
    var successEl = formEl.querySelector('[data-bis-success]');

    function showError(msg) {
      if (errorEl) {
        errorEl.textContent = msg;
        errorEl.removeAttribute('hidden');
      }
    }

    function hideError() {
      if (errorEl) errorEl.setAttribute('hidden', '');
    }

    function showSuccess() {
      formEl.querySelectorAll('[data-bis-form-row]').forEach(function (el) {
        el.setAttribute('hidden', '');
      });
      if (successEl) successEl.removeAttribute('hidden');
    }

    formEl.addEventListener('submit', function (e) {
      e.preventDefault();
      hideError();

      var email = (emailInput.value || '').trim();
      var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(email)) {
        emailInput.classList.add('is-invalid');
        showError('Please enter a valid email address.');
        return;
      }
      emailInput.classList.remove('is-invalid');

      var originalText = submitBtn.textContent;
      submitBtn.disabled = true;
      submitBtn.textContent = 'Sending...';

      var requestedAt = new Date().toISOString();

      var variantSelect = document.querySelector('[name="id"]');
      var variantId = variantSelect ? variantSelect.value : '';

      var profileAttrs = {
        email: email,
        properties: {
          back_in_stock_last_requested_product: productHandle,
          back_in_stock_last_requested_at: requestedAt
        }
      };

      var subscribePayload = LIST_ID
        ? {
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Back in Stock — ' + productTitle,
                profile: {
                  data: {
                    type: 'profile',
                    attributes: profileAttrs
                  }
                }
              },
              relationships: {
                list: { data: { type: 'list', id: LIST_ID } }
              }
            }
          }
        : null;

      var eventPayload = {
        data: {
          type: 'event',
          attributes: {
            metric: {
              data: { type: 'metric', attributes: { name: 'Back in Stock Requested' } }
            },
            profile: {
              data: { type: 'profile', attributes: { email: email } }
            },
            properties: {
              product_handle: productHandle,
              product_title: productTitle,
              product_id: productId,
              variant_id: variantId,
              product_url: productUrl,
              product_image_url: productImageUrl,
              product_price: productPrice,
              product_price_cents: productPriceCents,
              requested_at: requestedAt
            }
          }
        }
      };

      var subscribePromise = subscribePayload
        ? fetch(SUBSCRIBE_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', revision: REVISION },
            body: JSON.stringify(subscribePayload)
          }).then(function (res) {
            if (!res.ok && res.status !== 202) {
              throw new Error('Subscription failed: ' + res.status);
            }
          })
        : Promise.resolve();

      subscribePromise
        .then(function () {
          return fetch(EVENT_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', revision: REVISION },
            body: JSON.stringify(eventPayload)
          });
        })
        .then(function (res) {
          if (!res.ok && res.status !== 202) {
            throw new Error('Event failed: ' + res.status);
          }
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'back_in_stock_requested',
            product_handle: productHandle,
            product_title: productTitle
          });
          showSuccess();
        })
        .catch(function (err) {
          console.error('Back-in-stock submission error:', err);
          showError("Something went wrong. Please try again or email info@magnoliacoffeeco.com.");
          submitBtn.disabled = false;
          submitBtn.textContent = originalText;
        });
    });
  }

  function bootstrap() {
    document.querySelectorAll('[data-back-in-stock-form]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
